import { Elements } from '@stripe/react-stripe-js'
import { Stripe, loadStripe } from '@stripe/stripe-js'
import { getStripeSupportedLocale } from 'modules/profile/user-plan/utils/user-plan-stripe-utils'
import React, { PropsWithChildren, useEffect, useState } from 'react'
import useUser from 'shared/hooks/use-user'

const StripeWrapper = ({ children }: PropsWithChildren) => {
  const [stripe, setStripe] = useState<Promise<Stripe | null> | null>(null)
  const { user } = useUser()

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_STRIPE_API_KEY_PUBLIC) {
      const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_API_KEY_PUBLIC, {
        stripeAccount: process.env.NEXT_PUBLIC_STRIPE_ACCOUNT_ID,
      })
      setStripe(stripePromise)
    }
  }, [])

  return (
    <Elements
      stripe={stripe}
      options={{ locale: user?.dashboardLocale && getStripeSupportedLocale(user.dashboardLocale) }}
    >
      {children}
    </Elements>
  )
}

export default StripeWrapper
